import { Component, Object3D } from '@wonderlandengine/api';
import { property } from '@wonderlandengine/api/decorators.js';
import { GameRules } from './rules/game-rules.js';
import { Puzzle } from './puzzle.js';
import { CustomLogTag } from '../classes/Constants.js';
import { FallingObjectsSpawner } from './falling-objects-spawner.js';

export class GameMode extends Component {
    static TypeName = 'game-mode';

    @property.object({ required: true })
    gameRulesObject!: Object3D;

    @property.object({ required: true })
    fallingObjectSpawnerObject!: Object3D;

    rules: GameRules;
    spawner: FallingObjectsSpawner;

    start() {
        this.rules = this.gameRulesObject.getComponents()[0] as GameRules;

        if (!this.rules || !(this.rules instanceof GameRules)) {
            this.engine.log.error(
                CustomLogTag.Game,
                'GameRules object does not have a GameRules component attached'
            );
        }
        this.spawner =
            this.fallingObjectSpawnerObject.getComponents()[0] as FallingObjectsSpawner;
        if (!this.spawner || !(this.spawner instanceof FallingObjectsSpawner)) {
            this.engine.log.error(
                CustomLogTag.Game,
                'fallingObjectSpawner object does not have a FallingObjectsSpawner component attached'
            );
        }
    }

    /**
     * This is used for initializing the game.
     * In the original project this was called IEnumerator Start() and was a coroutine.
     */
    startGame() {
        const puzzle = Puzzle.instance;
        puzzle.rules = this.rules;

        this.spawner.initialize();

        puzzle.spawner = this.spawner;
        puzzle.startGame();
    }
}
